import React, {
    useState,
    useEffect
}
from "react";

import {
    FontAwesomeIcon
}
from "@fortawesome/react-fontawesome";

import {
    faChevronRight,
    faChevronDown,
    faChevronUp
}
from "@fortawesome/free-solid-svg-icons";

import {
    functions
}
from "../../../constants/common-functions";


export default function HeaderCard({
    id,
    title,
    icon,
    color,
    externalLinks
})
{
    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [showExtras, setShowExtras] =
        useState(false);

    const [filteredExternalLinks, setFilteredExternalLinks] =
        useState([]);


    //--------------------------------------------------------
    // Toggle extras
    //--------------------------------------------------------

    function toggleExtras()
    {
        setShowExtras(
            !showExtras
        );
    }


    //--------------------------------------------------------
    // External links
    //--------------------------------------------------------

    useEffect(
        function()
        {
            if(
                externalLinks
                &&
                externalLinks.length > 0
            )
            {
                const filtered =
                    externalLinks.filter(
                        function(link)
                        {
                            return (
                                link.pageIndex
                                ===
                                parseInt(id)
                            );
                        }
                    );

                setFilteredExternalLinks(
                    filtered
                );
            }
            else
            {
                setFilteredExternalLinks(
                    []
                );
            }
        },
        [externalLinks, id]
    );


    //========================================================
    // Container
    //========================================================

    const thisContainer =
    {
        display:
            "flex",

        flexDirection:
            "column",

        width:
            "calc(100% - 20px)",

        marginLeft:
            "10px",

        marginRight:
            "10px",

        marginTop:
            "10px",

        marginBottom:
            "10px",

        //----------------------------------------------------
        // Soft outer container
        //----------------------------------------------------

        borderRadius:
            "6px",

        //----------------------------------------------------
        // Frosted glass
        //----------------------------------------------------

        background:
            "rgba(255,255,255,0.64)",

        backdropFilter:
            "blur(16px)",

        WebkitBackdropFilter:
            "blur(16px)",

        //----------------------------------------------------
        // Fine glass edge
        //----------------------------------------------------

        border:
            "1px solid rgba(255,255,255,0.76)",

        //----------------------------------------------------
        // Light depth
        //----------------------------------------------------

        boxShadow:
            `
            0 7px 20px rgba(15,25,35,0.10),
            inset 0 1px 0 rgba(255,255,255,0.75)
            `,

        overflow:
            "hidden",

        transition:
            "all 0.2s ease",
			
		minHeight:'50px'
    };


    //========================================================
    // Header row
    //========================================================

    const topRow =
    {
        display:
            "flex",

        width:
            "100%",

        height:
            "46px",

        alignItems:
            "center",

        position:
            "relative",

        overflow:
            "hidden",

        cursor:
            "pointer"
    };


    //========================================================
    // Watermark
    //========================================================

    const watermarkStyle =
    {
        position:
            "absolute",

        right:
            "55px",

        top:
            "-30px",

        width:
            "110px",

        height:
            "110px",

        display:
            "flex",

        alignItems:
            "center",

        justifyContent:
            "center",

        color:
            "#111820",

        opacity:
            0.035,

        transform:
            "rotate(-8deg)",

        pointerEvents:
            "none",

        zIndex:
            1
    };


    const watermarkIconStyle =
    {
        width:
            "82px",

        height:
            "82px"
    };


    //========================================================
    // Left icon area
    //
    // This is now simply breathing room for the puck.
    // It is deliberately NOT itself coloured.
    //========================================================

    const leftWrapper =
    {
        display:
            "flex",

        width:
            "54px",

        height:
            "46px",

        alignItems:
            "center",

        justifyContent:
            "center",

        flexShrink:
            0,

        position:
            "relative",

        zIndex:
            2
    };


    //========================================================
    // Charcoal icon puck
    //
    // Slightly flatter than the 42x42 HomeBox puck because
    // this is a navigation/header control.
    //========================================================

    const leftIconContainer =
    {
        display:
            "flex",

        width:
            "42px",

        height:
            "42px",

        alignItems:
            "center",

        justifyContent:
            "center",

        flexShrink:
            0,

        borderRadius:
            "6px",

        //----------------------------------------------------
        // Charcoal treatment
        //----------------------------------------------------

        background:
            `
            linear-gradient(
                180deg,
                #292d31 0%,
                #15181b 100%
            )
            `,

        border:
            "none",

        boxShadow:
            `
            0 3px 10px rgba(0,0,0,0.18),
            inset 0 1px 0 rgba(255,255,255,0.10)
            `,

        overflow:
            "hidden",
		marginTop:'4px'
    };


    //--------------------------------------------------------
    // Icon
    //--------------------------------------------------------

    const iconStyle =
    {
        width:
            "18px",

        height:
            "18px",

        color:
            "#ffffff",

        filter:
            "drop-shadow(0 1px 2px rgba(0,0,0,.30))"
    };


    //========================================================
    // Title
    //========================================================

    const rightContainer =
    {
        display:
            "flex",

        flexDirection:
            "column",

        justifyContent:
            "center",

        flexGrow:
            1,

        paddingLeft:
            "10px",

        paddingRight:
            "10px",

        position:
            "relative",

        zIndex:
            2
    };


    const titleStyle =
    {
        fontSize:
            "15px",

        fontWeight:
            600,

        color:
            "#252b31",

        letterSpacing:
            "0.1px"
    };
	
	
	const titleUnderlineStyle =
	{
	    width:
	        "200px",

	    height:
	        "2px",

	    marginTop:
	        "5px",

	    background:
	        "#8dc8f0",

	    borderRadius:
	        "2px",

	    opacity:
	        0.85
	};


    //========================================================
    // Chevron
    //========================================================

    const chevronContainer =
    {
        display:
            "flex",

        width:
            "48px",

        height:
            "46px",

        alignItems:
            "center",

        justifyContent:
            "center",

        flexShrink:
            0,

        position:
            "relative",

        zIndex:
            3,

        color:
            "#4e5962"
    };


    //========================================================
    // Slide panel
    //========================================================

    const panelStyle =
    {
        overflow:
            "hidden",

        maxHeight:
            showExtras
                ?
                "400px"
                :
                "0px",

        opacity:
            showExtras
                ?
                1
                :
                0,

        transition:
            "max-height 0.35s cubic-bezier(0.22, 0.61, 0.36, 1), " +
            "opacity 0.22s ease",

        //----------------------------------------------------
        // Dark smoked glass
        //----------------------------------------------------

        background:
            "rgba(20,23,26,0.96)",

        backdropFilter:
            "blur(16px)",

        WebkitBackdropFilter:
            "blur(16px)",

        borderTop:
            "1px solid rgba(255,255,255,0.08)",

        boxShadow:
            "0 10px 24px rgba(0,0,0,0.18)"
    };


    //========================================================
    // Panel header
    //========================================================

    const panelHeader =
    {
        display:
            "flex",

        alignItems:
            "center",

        height:
            "36px",

        padding:
            "0 16px",

        fontWeight:
            600,

        //----------------------------------------------------
        // Small OmniScan blue accent
        //----------------------------------------------------

        color:
            "#8dc8f0",

        fontSize:
            "11px",

        letterSpacing:
            "1.2px",

        textTransform:
            "uppercase",

        background:
            "rgba(10,12,14,0.72)",

        borderBottom:
            "1px solid rgba(255,255,255,0.08)"
    };


    //========================================================
    // Links
    //========================================================

    const linkList =
    {
        padding:
            "0px"
    };


    const linkRow =
    {
        display:
            "flex",

        justifyContent:
            "space-between",

        alignItems:
            "center",

        minHeight:
            "40px",

        background:
            "rgba(34,37,40,0.76)",

        color:
            "rgba(255,255,255,0.88)",

        borderRadius:
            "0px",

        border:
            "none",

        borderBottom:
            "1px solid rgba(255,255,255,0.07)",

        marginBottom:
            "0px",

        cursor:
            "pointer",

        boxShadow:
            "none",

        transition:
            "all 0.16s ease",

        paddingLeft:
            "16px",

        paddingRight:
            "16px",

        fontSize:
            "13px",

        fontWeight:
            500
    };


    //--------------------------------------------------------
    // Link hover
    //--------------------------------------------------------

    const linkRowHover =
    {
        background:
            "rgba(48,53,58,0.96)",

        color:
            "#ffffff",

        paddingLeft:
            "20px",

        //----------------------------------------------------
        // Tiny OmniScan blue interaction accent
        //----------------------------------------------------

        boxShadow:
            "inset 3px 0 0 #8dc8f0"
    };


    //========================================================
    // External links
    //========================================================

    const externalLinkDisplay =
        filteredExternalLinks.map(
            (item, index) =>
            (
                <div
                    key={index}
                    style={linkRow}
                    onMouseEnter={
                        function(e)
                        {
                            Object.assign(
                                e.currentTarget.style,
                                linkRowHover
                            );
                        }
                    }
                    onMouseLeave={
                        function(e)
                        {
                            Object.assign(
                                e.currentTarget.style,
                                linkRow
                            );
                        }
                    }
                    onClick={
                        function()
                        {
                            window.location =
                                item.url;
                        }
                    }
                >

                    <span>

                        {item.title}

                    </span>

                    <FontAwesomeIcon
                        icon={faChevronRight}
                    />

                </div>
            )
        );


    //========================================================
    // Demo links
    //========================================================

    const demoLinksData =
    [
        {
            id:
                "100",

            title:
                "Outliers",

            url:
                "/outliers"
        },

        {
            id:
                "101",

            title:
                "Asset Condition",

            url:
                "/assets/conditionmatrix"
        },

        {
            id:
                "102",

            title:
                "Matterport Scan Demo (With Tags)",

            url:
                "/matterport"
        },

        {
            id:
                "103",

            title:
                "Giraffe 360 Scan Demo",

            url:
                "/giraffe"
        },

        {
            id:
                "104",

            title:
                "Asset Tagging",

            url:
                "/administration/giraffe"
        },

        {
            id:
                "105",

            title:
                "AI Document Generator",

            url:
                "/insightsdocumentgenerator"
        },

        {
            id:
                "106",

            title:
                "DWG Interrogator",

            url:
                "/dwginteraction"
        }
    ];
	
	
	//========================================================
	   // Demo links
	   //========================================================

	   const demoLinksDocument =
	   [
	       {
	           id:
	               "100",

	           title:
	               "Document Builder",

	           url:
	               "/snippetsearch"
	       }	    
	   ];


    //========================================================
    // Render
    //========================================================

    return (
        <div style={thisContainer}>


            {/* ================================================
                HEADER
            ================================================= */}

            <div
                style={topRow}
                onClick={toggleExtras}
            >


                {/* --------------------------------------------
                    Watermark
                --------------------------------------------- */}

                <div style={watermarkStyle}>

                    <FontAwesomeIcon
                        icon={icon}
                        style={watermarkIconStyle}
                    />

                </div>


                {/* --------------------------------------------
                    Charcoal icon puck
                --------------------------------------------- */}

                <div style={leftWrapper}>

                    <div style={leftIconContainer}>

                        <FontAwesomeIcon
                            icon={icon}
                            style={iconStyle}
                        />

                    </div>

                </div>


                {/* --------------------------------------------
                    Title
                --------------------------------------------- */}

                <div style={rightContainer}>

                    <div style={titleStyle}>

                        {title}

                    </div>
					<div style={titleUnderlineStyle} />

                </div>


                {/* --------------------------------------------
                    Chevron
                --------------------------------------------- */}

                <div style={chevronContainer}>

                    <FontAwesomeIcon
                        icon={
                            showExtras
                                ?
                                faChevronUp
                                :
                                faChevronDown
                        }
                    />

                </div>

            </div>


            {/* ================================================
                EXPANDING PANEL
            ================================================= */}

            <div style={panelStyle}>


                <div style={panelHeader}>

                    Additional Links

                </div>


                <div style={linkList}>


                    {/* ----------------------------------------
                        Demo links  Data
                    ----------------------------------------- */}

                    {
                        id === "1"
                        &&
                        functions.getIsDemoSystem()
                        &&
                        demoLinksData.map(
                            (item) =>
                            (
                                <div
                                    key={item.id}
                                    style={linkRow}
                                    onMouseEnter={
                                        function(e)
                                        {
                                            Object.assign(
                                                e.currentTarget.style,
                                                linkRowHover
                                            );
                                        }
                                    }
                                    onMouseLeave={
                                        function(e)
                                        {
                                            Object.assign(
                                                e.currentTarget.style,
                                                linkRow
                                            );
                                        }
                                    }
                                    onClick={
                                        function()
                                        {
                                            window.location =
                                                item.url;
                                        }
                                    }
                                >

                                    <span>

                                        {item.title}

                                    </span>

                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                    />

                                </div>
                            )
                        )
                    }
					
					
					{/* ----------------------------------------
				Demo links  Data
                   ----------------------------------------- */}

                   {
                       id === "2"
                       &&
                       functions.getIsDemoSystem()
                       &&
                       demoLinksDocument.map(
                           (item) =>
                           (
                               <div
                                   key={item.id}
                                   style={linkRow}
                                   onMouseEnter={
                                       function(e)
                                       {
                                           Object.assign(
                                               e.currentTarget.style,
                                               linkRowHover
                                           );
                                       }
                                   }
                                   onMouseLeave={
                                       function(e)
                                       {
                                           Object.assign(
                                               e.currentTarget.style,
                                               linkRow
                                           );
                                       }
                                   }
                                   onClick={
                                       function()
                                       {
                                           window.location =
                                               item.url;
                                       }
                                   }
                               >

                                   <span>

                                       {item.title}

                                   </span>

                                   <FontAwesomeIcon
                                       icon={faChevronRight}
                                   />

                               </div>
                           )
                       )
                   }


                    {/* ----------------------------------------
                        Configured external links
                    ----------------------------------------- */}

                    {externalLinkDisplay}


                </div>

            </div>

        </div>
    );
}